module.exports = __webpack_public_path__ + "static/media/hcm-binh-thanh.ef7a4cd1.svg";